import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import BrandLogo from '@/components/common/BrandLogo';
import UserActions from '@/components/layout/UserActions';
import { useAuth } from '@/contexts/AuthContext';

const Header = () => {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center justify-between px-4">
        <Link to="/" className="flex items-center">
          <BrandLogo />
        </Link>
        <nav className="flex items-center space-x-4">
          {user ? (
            <UserActions variant="app" />
          ) : (
            <>
              <Button asChild variant="ghost">
                <Link to="/auth">Login</Link>
              </Button>
              <Button asChild>
                <Link to="/auth?register=true">Register</Link>
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export { Header };
export default Header;
